import styled from "styled-components"

export const H2 = styled.h2`
  display: inline-block;
  font-size: 1.6em;
  word-wrap: break-word;
  width: 100%;
`
